module.exports = __webpack_public_path__ + "img/client25.d42d8c78.svg";